import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

// Documents
const ProjectionsList = () => import(/* webpackChunkName: "projections" */ '@/views/Projection/List.vue');
const ProjectionCreate = () => import(/* webpackChunkName: "projections" */ '@/views/Projection/Create.vue');
const ProjectionShow = () => import(/* webpackChunkName: "projections" */ '@/views/Projection/Show.vue');

const ProjectionStatistics = () => import(/* webpackChunkName: "projections" */ '@/views/Projection/Statistics.vue');
const ProjectionGenerate = () => import(/* webpackChunkName: "projections" */ '@/views/Projection/Generate/Index.vue');
const ProjectionGeneratePreview = () =>
  import(/* webpackChunkName: "projections" */ '@/views/Projection/Generate/Preview.vue');
const ProjectionAssociateOrders = () =>
  import(/* webpackChunkName: "projections" */ '@/views/Projection/AssociateOrders.vue');
const ProjectionCharts = () => import(/* webpackChunkName: "projections" */ '@/views/Projection/Charts.vue');

let projectionsPages = {
  path: '/projections',
  redirect: '/projections',
  component: DashboardLayout,
  name: 'Projections',
  meta: {
    title: 'Proyección de ventas',
    auth: true,
  },
  children: [
    {
      path: '',
      name: 'ProjectionsList',
      meta: {
        title: 'Listado',
        auth: ['projections.index'],
      },
      component: ProjectionsList,
    },
    {
      path: 'create',
      name: 'ProjectionCreate',
      meta: {
        title: 'Nuevo',
        auth: ['projections.store'],
      },
      component: ProjectionCreate,
    },
    {
      path: 'statistics',
      name: 'ProjectionStatistics',
      meta: {
        title: 'Estadísticas',
        auth: ['projections.statistics'],
      },
      component: ProjectionStatistics,
    },
    {
      path: 'generate',
      name: 'ProjectionGenerate',
      meta: {
        title: 'Generar',
        auth: ['projections.generate'],
      },
      component: ProjectionGenerate,
    },
    {
      path: 'generate/preview',
      name: 'ProjectionGeneratePreview',
      meta: {
        title: 'Pedidos a proyectar',
        auth: ['projections.generate'],
      },
      component: ProjectionGeneratePreview,
    },
    {
      path: 'charts',
      name: 'ProjectionCharts',
      meta: {
        title: 'Gráficas',
        auth: ['projections.charts'],
      },
      component: ProjectionCharts,
    },
    {
      path: ':id',
      name: 'ProjectionShow',
      meta: {
        title: 'Mostrar',
        auth: ['projections.show'],
      },
      component: ProjectionShow,
    },
    {
      path: ':id/associate-order',
      name: 'ProjectionAssociateOrders',
      meta: {
        title: 'Asociar pedido',
        auth: ['projections.associate_order'],
      },
      component: ProjectionAssociateOrders,
    },
  ],
};

export default projectionsPages;
